import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import IsProdEnvironment from '~/app/utils/is-production-environment';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	printServiceUrl: {
		url: 'https://formsccf.audi.be/ccf/default.aspx?lg={{language}}&action=pdf&code={{audiCode}}',
		pathParams: {},
		queryParams: [],
	},
	financeDomain: 'AUDI.BE',
	enableFinancingServices: !IsProdEnvironment(),
	hideMonthlyRates: IsProdEnvironment(),
	nextBestActions: [
		{
			description: 'Ontdek onze stockwagens',
			icon: '',
			labelText: 'Stockwagens',
			trackingName: 'go to vtp',
			target: '_blank',
			url: 'https://stock.audi.be/{{language}}/',
		},
		{
			description: 'Contacteer een Audi verdeler',
			icon: 'send',
			labelText: 'Contacteer een Audi verdeler',
			target: '_blank',
			trackingName: 'contact',
			url: 'https://formsccf.audi.be/ccf/default.aspx?lg={{language}}&action=offer&code={{audiCode}}',
		},
		{
			description: 'Een testrit boeken ',
			icon: 'test-drive',
			labelText: 'Een testrit boeken',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://formsccf.audi.be/ccf/default.aspx?lg={{language}}&action=td&code={{audiCode}}',
		},
	],
	summaryFooterCta: {
		description: 'Bereken uw maandprijs',
		icon: 'calculator',
		labelText: 'Bereken uw maandprijs',
		trackingName: 'online leasing',
		target: '_blank',
		url: 'https://formsccf.audi.be/ccf/finance/index?lg={{language}}&code={{audiCode}} ',
	},
};
